import { z } from "zod";
export const PageBlockDefinitionAppearance = z.object({
    isBordered: z.boolean().optional(),
    hasBackground: z.boolean().optional(),
    isEditorPresentationDifferent: z.boolean().optional(),
    showBlockHeaderInEditor: z.boolean().optional(),
});
